// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://anndvinwiqtjmeualrrz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFubmR2aW53aXF0am1ldWFscnJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3MzY4NjMsImV4cCI6MjA3MTMxMjg2M30.owu0CpAFh14Rw4QjFLvIBPQLR-jBeoe2Dw6vPS9gpB8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});